import { LAYER } from 'js/components/common/PopupManager/layers';
import { ADD_POPUP } from 'js/components/common/PopupManager/store/actions';
import { TransparentPopup } from './TransparentPopup';

/**
 * @param {Object} object
 * @param {string} [object.id]
 * @param {string} [object.title]
 * @param {string} [object.content]
 * @param {Function} [object.onClose]
 * @param {boolean} [object.closeAll]
 * @param {string} [object.layer]
 * @param {boolean} [object.isModal]
 * @param {string} [object.articleId]
 * @param {object[]} [object.buttons]
 * @param [other]
 */
export const showTransparentPopupAction = ({
    id,
    title,
    content,
    onClose,
    closeAll,
    layer = LAYER.COMMON,
    isModal = false,
    articleId,
    ...other
}) => ({
    type: ADD_POPUP,
    payload: {
        id,
        component: TransparentPopup,
        title,
        content,
        onClose,
        closeAll,
        layer,
        isModal,
        articleId,
        ...other
    }
});
